import type { TOC } from '@ember/component/template-only'
import { and, not } from 'ember-truth-helpers'

interface SiteHeaderNavButtonSignature {
  Element: HTMLButtonElement
  Args: {
    isOpen?: boolean
    /**
     * True if currently on one of the pages from the dropdown
     */
    currentWhen?: boolean
  }
  Blocks: {
    default: []
  }
}

export const SiteHeaderNavButton: TOC<SiteHeaderNavButtonSignature> = <template>
  <button
    type="button"
    class="group inline-block text-base font-medium text-neutral-300 focus:outline-none"
    ...attributes
  >
    {{! separator to keep text vertically centered, balancing the line on the other side }}
    <div class="h-1 w-full" />
    <div
      class="{{if (and @currentWhen (not @isOpen)) 'text-blue-325'}}
        {{if @isOpen 'bg-blue-100 text-blue-350' 'group-hover:bg-neutral-75 group-active:bg-neutral-100'}}
        my-3 space-x-2 rounded-lg px-4 py-2 group-focus:outline-blue-325 group-focus-visible:outline group-focus-visible:outline-2 group-focus-visible:outline-offset-2"
    >
      {{yield}}
    </div>
    <div
      class="{{if @currentWhen 'bg-blue-325'}} h-1 w-full rounded-t-sm transition-colors duration-200 ease-in-out"
    ></div>
  </button>
</template>
